<form [formRoot]="organizationForm()" class="space-y-6">
  <div hlmFieldGroup>
    <fieldset hlmFieldSet>
      <legend hlmFieldLegend>
        {{ 'settings.organizations.details.sections.info' | transloco }}
      </legend>

      <div hlmFieldGroup class="mt-4">
        <div
          hlmField
          [attr.data-invalid]="organizationForm().name().touched() && organizationForm().name().invalid()"
        >
          <label hlmFieldLabel for="organization-name">
            {{ 'settings.organizations.form.fields.name' | transloco }}
          </label>
          <input
            id="organization-name"
            hlmInput
            type="text"
            autocomplete="organization"
            class="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs"
            [formField]="organizationForm().name"
            [placeholder]="'settings.organizations.form.fields.name' | transloco"
            [attr.aria-invalid]="organizationForm().name().touched() && organizationForm().name().invalid()"
          />
          @if (organizationForm().name().touched() && organizationForm().name().invalid()) {
            @for (err of organizationForm().name().errors(); track $index) {
              <hlm-field-error [forceShow]="true">{{ err.message | transloco }}</hlm-field-error>
            }
          }
        </div>
      </div>
    </fieldset>
  </div>
</form>
